import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Card, CardBody } from "reactstrap";
import axios from "axios";
import { PortfolioTitle } from "../../Constant";
import { H4, P } from "../../AbstractElements";
import { ImageLightApi, BigImageApi } from "../../api";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";

const PhotosTab = () => {
  const description =
    "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
  // eslint-disable-next-line no-unused-vars
  const [images, setImage] = useState([]);
  const [smallImages, setsmallImages] = useState([]);

  useEffect(() => {
    axios.get(ImageLightApi).then((response) => {
      setImage(response.data.src);
    });
    axios.get(BigImageApi).then((response) => {
      setsmallImages(response.data.src);
    });
  }, []);

  return (
    <Fragment>
      <Row>
        {smallImages && (
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="my-gallery gallery-with-description">
                  <Row>
                    <Gallery>
                      {smallImages &&
                        smallImages.map((item, i) => {
                          return (
                            <Col xl={3} sm={6} key={i}>
                            <figure>
                              <Item original={require(`../../assets/images/${item}`)} thumbnail={require(`../../assets/images/${item}`)} width="1024" height="768" caption="hello">
                                {({ ref, open }) => (
                                  <Link onClick={open}>
                                    <img
                                      className="img-thumbnail"
                                      ref={ref}
                                      src={require(`../../assets/images/${item}`)}
                                      alt=""
                                    />
                                    <div className="caption">
                                      <H4>{PortfolioTitle}</H4>
                                      <P>{description}</P>
                                    </div>
                                  </Link>
                                )}
                              </Item>
                            </figure>
                          </Col>
                          );
                        })}
                    </Gallery>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        )}
      </Row>
    </Fragment>
  );
};
export default PhotosTab;